import axios from "axios";
import { env } from "../utils/env";
import { useAuth } from "../context/AuthContext";
import { useQuery } from "@tanstack/react-query";
import { useNavigate } from "react-router-dom";
import { ROUTE } from "../routes";

type Scope = "all" | "individual" | "entity";

export interface AddressType {
  id: number;
  name: string;
  active: boolean;
  _type: "individual" | "entity";
  is_default: boolean;
  order: number | null;
  updated_at: string;
}

const fetch = (authHeader: string, scope: Scope, activeOnly: boolean) => async () => {
  const base = `${env.verifyServiceUrl}individual/address_type/`;
  const url =
    scope === "all" ? `${base}?all=true` : `${base}?_type=${scope}&all=true`;

  const res = await axios.get<AddressType[]>(
    activeOnly ? `${url}&active=true` : url,
    { headers: { Authorization: authHeader } },
  );

  return res.data;
};

export const useGetAddressTypeList = (
  scope: Scope = "all",
  activeOnly = false,
) => {
  const { authHeader } = useAuth();
  const navigate = useNavigate();

  return useQuery<AddressType[], Error>(
    ["address_type_list", scope, activeOnly],
    fetch(authHeader, scope, activeOnly),
    {
      retry: false,
      onError: (err: any) => {
        const status = err?.response?.status ?? err?.request?.status;
        if (status === 500 || status === 503) navigate(ROUTE.SERVER_ERROR);
        if (status === 401) navigate(ROUTE.LOGOUT);
      },
    }
  );
};
